import { useState } from 'react';
import { Bell } from 'lucide-react';
import { useNotificationStore } from '@/store/notificationStore';
import { NotificationDropdown } from './NotificationDropdown';

export function NotificationBell() {
  const [isOpen, setIsOpen] = useState(false);
  const unreadCount = useNotificationStore((state) => state.unreadCount);

  return (
    <>
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`
            relative group rounded-xl p-2.5
            transition-all duration-300 ease-in-out
            ${isOpen
              ? 'bg-gradient-to-br from-purple-500 to-pink-500 shadow-lg scale-110'
              : 'bg-gray-100 dark:bg-gray-700 hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500 hover:scale-105'
            }
          `}
          aria-label="Notifications"
        >
          {/* Bell Icon */}
          <Bell
            className={`
              h-5 w-5 transition-all duration-300
              ${isOpen
                ? 'text-white animate-wiggle'
                : 'text-gray-700 dark:text-gray-300 group-hover:text-white'
              }
            `}
          />

          {/* Badge Count */}
          {unreadCount > 0 && (
            <span className="absolute -right-1 -top-1 flex items-center justify-center">
              {/* Pulse rings */}
              <span className="absolute flex h-4 w-4">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"></span>
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-50" style={{ animationDelay: '0.5s' }}></span>
              </span>

              {/* Badge */}
              <span className={`relative flex items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-pink-500 text-white font-bold shadow-lg ring-2 ring-white dark:ring-gray-800 z-10 ${unreadCount > 99 ? 'h-5 min-w-[1.5rem] px-1 text-[9px]' : 'h-5 min-w-[1.25rem] px-0.5 text-[10px]'}`}>
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            </span>
          )}

          {/* Hover glow effect */}
          <div className={`
            absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300
            bg-gradient-to-br from-purple-500/20 to-pink-500/20 blur-xl -z-10
          `}></div>
        </button>
      </div>

      <NotificationDropdown isOpen={isOpen} onClose={() => setIsOpen(false)} />

      {/* Add wiggle animation */}
      <style>{`
        @keyframes wiggle {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-10deg); }
          75% { transform: rotate(10deg); }
        }
        .animate-wiggle {
          animation: wiggle 0.5s ease-in-out infinite;
        }
      `}</style>
    </>
  );
}
